<lib-conversation-info
  [conversationInfo]="data"
  (conversationClicked)="selectConversation($event)"
></lib-conversation-info>
